import React, {useEffect, useRef} from 'react';
import {useAppSelector} from '../store/hooks';
import Polls from '../components/Polls';
import {Page} from '../types/enums/page.enum';
import Results from './Results';
import FormPage from './FormPage';
import {styled} from '@volkswagen-onehub/components-core';

const PagesContainer = styled.div``;

export default () => {
  const pageRef = useRef<HTMLDivElement | null>(null);

  const page = useAppSelector((state) => state.page.value);

  useEffect(() => { window.scrollTo(0, 0); }, [page]);

  return (
    <PagesContainer ref={pageRef}>
      {page == Page.POLL ? <Polls /> : null}
      {page == Page.FORM ? <FormPage /> : null}
      {page == Page.RESULT ? <Results /> : null}
    </PagesContainer>
  );
};
